import { Box } from 'reflexbox';
import styled from 'styled-components';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

const TalentReviewLabelField = styled(Box)<{ vertical?: boolean }>`
	white-space: pre;
	cursor: text;

	svg {
		display: block;
	}

	${(props) =>
		props.vertical &&
		`
		position: absolute;
		left: 50%;
		transform: translateX(-50%) translateY(-50%) rotateZ(-90deg);
		transition: .4s cubic-bezier(0.16, 1, 0.3, 1) transform;
`}
`;

export default function TalentReviewLabel(props: {
	text: graphql.LocalizedString;
	vertical?: boolean;
}) {
	const { localize } = useLocalize();

	return (
		<TalentReviewLabelField vertical={props.vertical} px={3} py={2}>
			{localize(props.text)?.text ?? '---'}
		</TalentReviewLabelField>
	);
}
